import { LOCKSCREEN, LOGOUT, MY_PROFILE } from "@constants/routes";
import UserContext from "@context/UserContext";
import avatar_logo from "@images/shared/profile-default.png";
import DownIcon from "mdi-react/ChevronDownIcon";
import { ReactElement, useContext, useState } from "react";
import { Collapse } from "reactstrap";
import { TUserContext } from "types/Core/Authentication/userContext";
import TopbarMenuLink from "../TopbarMenuLink";

const TopbarProfile = (): ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { currentUser, HandleLogout, HandleLockScreen } =
    useContext<TUserContext>(UserContext);

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="topbar__profile">
      <button
        type="button"
        className="topbar__avatar"
        onClick={handleToggleCollapse}
      >
        <img className="topbar__avatar-img" src={avatar_logo} alt="avatar" />
        <p className="topbar__avatar-name">{currentUser?.userName}</p>
        <DownIcon className="topbar__icon" />
      </button>
      {isCollapsed && (
        <button
          type="button"
          aria-label="button collapse"
          className="topbar__back"
          onClick={handleToggleCollapse}
        />
      )}
      <Collapse isOpen={isCollapsed} className="topbar__menu-wrap">
        <div className="topbar__menu">
          <TopbarMenuLink
            title={"My Profile"}
            icon="list"
            path={MY_PROFILE}
            onclick={handleToggleCollapse}
          />
          <div className="topbar__menu-divider" />
          <TopbarMenuLink
            title={"Lock Screen"}
            icon="lock"
            path={LOCKSCREEN}
            onclick={HandleLockScreen}
          />
          <TopbarMenuLink
            title={"Log out"}
            icon="exit"
            path={LOGOUT}
            onclick={HandleLogout}
          />
        </div>
      </Collapse>
    </div>
  );
};

export default TopbarProfile;
